import { render, staticRenderFns } from "./LiteBadge.vue?vue&type=template&id=5cd1ab65&scoped=true&"
import script from "./LiteBadge.vue?vue&type=script&lang=js&"
export * from "./LiteBadge.vue?vue&type=script&lang=js&"
import style0 from "./LiteBadge.vue?vue&type=style&index=0&id=5cd1ab65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd1ab65",
  null
  
)

export default component.exports